import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('auth', 'send-invitation');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'send_invitation',
  type: 'post',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/auth/send-invitation-req.js